import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const AbutmentPlanningAI = () => {
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const handleGenerate = async () => {
    if (!prompt.trim()) {
      toast.error("Bitte geben Sie eine Beschreibung ein");
      return;
    }

    setLoading(true);
    setResult("");

    try {
      const { data, error } = await supabase.functions.invoke("ai-abutment-planning", {
        body: { prompt }
      });

      if (error) throw error;

      setResult(data.result);
      toast.success("Planung erfolgreich generiert");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Fehler bei der KI-Generierung");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-primary" />
          KI-gestützte Abutment-Planung
        </CardTitle>
        <CardDescription>
          Nutzen Sie KI zur Unterstützung bei der Planung von EAP® Abutments
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">
            Beschreiben Sie die klinische Situation
          </label>
          <Textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="z.B. Patient mit anteriorem Einzelzahnverlust Regio 11, mittlere Gingivahöhe, ausreichendes Knochenangebot..."
            rows={4}
            disabled={loading}
          />
        </div>

        <Button 
          onClick={handleGenerate} 
          disabled={loading}
          className="w-full"
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Generiere Planung...
            </>
          ) : (
            <>
              <Sparkles className="mr-2 h-4 w-4" />
              Planung generieren
            </>
          )}
        </Button>

        {result && (
          <div className="mt-6 p-4 border rounded-lg bg-muted/50">
            <h4 className="font-semibold mb-2">KI-Empfehlung:</h4>
            <div className="prose prose-sm max-w-none whitespace-pre-line">
              {result}
            </div>
          </div>
        )}

        <div className="text-xs text-muted-foreground border-t pt-4">
          <p className="font-semibold mb-1">⚠️ Wichtiger Hinweis:</p>
          <p>
            Diese KI-gestützte Planung dient ausschließlich als Unterstützung und ersetzt nicht 
            die fachliche Beurteilung durch qualifiziertes medizinisches Personal. 
            Alle Empfehlungen müssen vom behandelnden Arzt überprüft und freigegeben werden.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
